module.exports = __webpack_public_path__ + "static/media/insta7.9ef99252.jpg";